import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import firebase from 'firebase';
import uuidv4 from 'uuid/v4';

class EditImageSidebar extends React.Component {
  static propTypes = {
    onChangeImage: PropTypes.func.isRequired,
  };

  onDrop = async files => {
    const file = files[0];
    const storageRef = firebase.storage().ref('infographic-images');
    const imageRef = storageRef.child(uuidv4());
    const res = await imageRef.put(file);
    this.props.onChangeImage(res.downloadURL);
  };

  render() {
    return (
      <div>
        <Dropzone
          style={{
            width: '80%',
            marginLeft: 'auto',
            marginRight: 'auto',
            border: '1px solid white',
            color: 'white',
            height: '100px',
            padding: '15px',
            marginTop: '25px',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onDrop={this.onDrop}
          accept="image/*"
        >
          <p>
            Drag an image here or click to select an image from your computer.
          </p>
        </Dropzone>
      </div>
    );
  }
}

export default EditImageSidebar;



// WEBPACK FOOTER //
// ./src/components/EditImageSidebar/EditImageSidebar.js